/**
 * Input types have been limited to text, email and phone numbers.
 * Use NumberInput for all your number input needs.
 * Specific components for PasswordInput, DateInput, SearchInput and others are likely in future.
 */
export var InputType;
(function (InputType) {
    InputType["Text"] = "text";
    InputType["Email"] = "email";
    InputType["Phone"] = "tel";
    InputType["Password"] = "password";
    InputType["Number"] = "number";
    InputType["Decimal"] = "decimal";
})(InputType || (InputType = {}));
export const defaultInputType = InputType.Text;
//# sourceMappingURL=type.js.map